import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { Discussion } from '../models/discussion.model';
import { AddCommentRequest } from '../models/requests/add-comment-request';

@Injectable({
  providedIn: 'root',
})
export class DiscussionService {
  constructor(private apiService: ApiService) {}

  public GetByRuleUid(ruleUid: string): Observable<Discussion> {
    const options = {
      queryParams: {
        ruleUniqueId: ruleUid.toString(),
      },
    };
    return this.apiService.get<Discussion>(
      `/Discussion/GetByRuleUidAsync`,
      options
    );
  }

  public GetWithMessagesByUid(discussionUid: string): Observable<Discussion> {
    return this.apiService.get<Discussion>(
      `/Discussion/GetWithMessagesByUidAsync/${discussionUid}`
    );
  }

  public AddDiscussionMessage(discussionMessage: AddCommentRequest): Observable<any> {
    return this.apiService.post(`/DiscussionMessage/Add`, discussionMessage);
  }
}
